import script from "./DacklTextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DacklTextInput.vue?vue&type=script&setup=true&lang=ts"

import "./DacklTextInput.vue?vue&type=style&index=0&id=19dfb9c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19dfb9c4"]])

export default __exports__